module.exports = __webpack_public_path__ + "epdf-app/dashboard/message-route-1ehD4S-M.html";